module.exports = __webpack_public_path__ + "static/img/zanting.8691c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zanting.png
// module id = qeWg
// module chunks = 24